import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import NavbarTwo from "../../Components/Navbar/navbarTwo";
import Footer from "../../Components/Footer";
import BottomNavbar from "../../Components/Navbar/bottomNavbar";

interface Article {
  id: number;
  title: string;
  slug: string;
  image: string;
  body: string;
  created_at: string;
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL!;

const DetailBeritaPage: React.FC = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState<Article | null>(null);
  const [otherArticles, setOtherArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/articles/${slug}`);
        const json = await res.json();
        setArticle(json);
      } catch (error) {
        console.error("Gagal ambil detail:", error);
      }
    };

    const fetchOthers = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/articles?page=1`);
        const json = await res.json();
        setOtherArticles(json.data || []);
      } catch (error) {
        console.error("Gagal ambil artikel lain:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
    fetchOthers();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [slug]);

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  if (loading) {
    return (
      <>
        <NavbarTwo />
        <div className="py-40 text-center">Loading...</div>
        <Footer />
      </>
    );
  }

  if (!article) return null;

  return (
    <>
      <NavbarTwo />

      <section className="bg-white py-24 md:py-32 font-signika">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            {/* ================= MAIN CONTENT ================= */}
            <div className="lg:col-span-8">
              <span className="text-xs font-semibold bg-primary2/10 text-primary2 px-3 py-1 rounded-full">BERITA</span>

              <h1 className="text-2xl md:text-4xl font-bold mt-4 mb-4 leading-snug">{article.title}</h1>

              <div className="text-sm text-gray-500 mb-6">Admin • {formatDate(article.created_at)}</div>

              <img src={`${API_BASE_URL}/uploads/articles/${article.image}`} alt={article.title} className="w-full rounded-2xl mb-8" />

              <div className="prose max-w-none text-gray-700 leading-relaxed whitespace-pre-line">{article.body}</div>
            </div>

            {/* ================= SIDEBAR ================= */}
            <div className="lg:col-span-4">
              <div className="bg-gray-50 rounded-2xl ">
                <h3 className="text-lg font-semibold mb-6 underline">Berita Lainnya</h3>

                <div className="space-y-5">
                  {otherArticles
                    .filter((item) => item.slug !== slug)
                    .slice(0, 5)
                    .map((item) => (
                      <Link key={item.id} to={`/berita/${item.slug}`} className="flex gap-4 group">
                        <img src={`${API_BASE_URL}/uploads/articles/${item.image}`} alt={item.title} className="w-20 h-16 object-cover rounded-lg" />

                        <div>
                          <h4 className="text-sm font-semibold group-hover:text-primary2 transition line-clamp-2">{item.title}</h4>
                          <p className="text-xs text-gray-500 mt-1">{formatDate(item.created_at)}</p>
                        </div>
                      </Link>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <BottomNavbar />
    </>
  );
};

export default DetailBeritaPage;
